module.exports = __webpack_public_path__ + "media/sun.72238529.svg";